import gql from "graphql-tag";
import AnswerablePostFields from "lib/graphql/fragments/engagement/AnswerablePostFields";

export default gql`
  mutation UnsetPostReplyAnswer($replyId: ObjectID!) {
    unsetPostReplyAnswer(replyId: $replyId) {
      ...AnswerablePostFields
    }
  }

  ${AnswerablePostFields}
`;
